'use strict';

function DynamicViewSelector() {
	return {
		restrict: 'E',
		template: '<ng-include src="getTemplateUrl()"></ng-include>',
		link: function(scope, iElem, iAttrs) {
			scope.getTemplateUrl = function() {
				return 'views/' + ((iAttrs.baseUrl) ? iAttrs.baseUrl : '') + '/' + iAttrs.contextType.toLowerCase().replace("_", "-") + '.html';
			}
		}
	}
}

export default DynamicViewSelector


// WEBPACK FOOTER //
// ./src/app/scripts/directives/dynamicViewSelectorDirective.js